module.exports = __webpack_public_path__ + "img/wellbookings_admin_screenshot.4afb033a.png";